import Body from "./videos/foot-body.mp4";
import Sides from "./videos/sides.mp4";
import Mister from "./videos/mister-foot-ram3thy.mp4";
import OutTheGates from "./videos/out-the-gates.mp4";
import AfterYou from "./videos/after-you.mp4";
import Molly from "./videos/molly.mp4";
import Runningback from "./videos/runningback.mp4";

export const videos = {
  Body: Body,
  Sides: Sides,
  Mister: Mister,
  OutTheGates: OutTheGates,
  AfterYou: AfterYou,
  Molly: Molly,
  Runningback: Runningback,
};
